import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Optional,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-measurement-add-buttons',
  templateUrl: './measurement-add-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasurementAddButtonsComponent {
  @Input() editMode: boolean;
  @Input() isLoading: boolean;
  @Input() formValid: boolean;

  constructor(@Optional() protected modal: NgbActiveModal) {}

  protected openDeleteConfirmation(): void {
    this.modal.dismiss('delete');
  }
}
